import React from 'react';
import { Button as DefaultButton, SmallLoader as DefaultSmallLoader } from 'framework/ui/mui-builder';
import { useListContext } from 'framework/list';
import { TimelineContextData } from '../Timeline';
import { useUiTheme } from 'framework/uiTheme';
import { Box } from '@mui/material';

type LoadMoreProps = {
  children?: React.ReactNode;
};

const LoadMore = ({ children }: LoadMoreProps) => {
  const { Button: ThemedButton, SmallLoader: ThemedSmallLoader } = useUiTheme();
  const Button = ThemedButton || DefaultButton;
  const SmallLoader = ThemedSmallLoader || DefaultSmallLoader;
  const loaderContainer = (
    <Box display="flex" justifyContent="center">
      <SmallLoader />
    </Box>
  );
  const {
    hasMoreData = () => false,
    hasLessData = () => false,
    loadNextPage,
    loadPreviousPage,
    isLoadingNextPage,
    isLoadingPrevPage,
  }: TimelineContextData = useListContext();

  return (
    <div>
      {isLoadingPrevPage && loaderContainer}
      {hasLessData() && (
        <Button onClick={loadPreviousPage} sx={{ display: 'block', mb: 1, mx: 'auto' }}>
          Load Previous Page
        </Button>
      )}
      {children}
      {hasMoreData() && (
        <Button onClick={loadNextPage} sx={{ display: 'block', mx: 'auto' }}>
          Load Next Page
        </Button>
      )}
      {isLoadingNextPage && loaderContainer}
    </div>
  );
};

export default LoadMore;
